export default __webpack_public_path__ + "static/media/MonthlyReportLightActive.cc7ba719.svg";